import { inject, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon, ButtonIcon, DialogBase, AppDialogRef } from '@/app/shared/components/ui';

@Component({
  selector: 'app-dialog-header',
  imports: [SvgIcon, ButtonIcon],
  templateUrl: './dialog-header.html',
  styleUrl: './dialog-header.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'dialog-header',
  },
})
export class DialogHeader {
  private readonly dialogRef = inject(AppDialogRef<DialogBase<any, any>>);

  closeDialog() {
    this.dialogRef.cancel();
  }
}
